import React from "react";
import Success from "../../../../assets/assets/nip-approved.svg";
import { PropTypes } from "prop-types";

const SuccessModal = ({ hide }) => {
  return (
    <div className="success-modal-body">
      <div className="modal-image">
        <img src={Success} alt="icon" />
      </div>
      <h3>Documents Sent</h3>
      <p>
        Your documents have been sent for review. Kindly check back when <br />{" "}
        admin approves
      </p>
      <div className="modal-btn">
        <button data-testid="hide" onClick={() => hide()}>continue</button>
      </div>
    </div>
  );
};

SuccessModal.propTypes = {
  hide: PropTypes.any,
};

export default SuccessModal;
